import { z } from 'zod';

export enum MaestraSignalExceptionType {
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    BAD_REQUEST = 'BAD_REQUEST',
    AUTHENTICATION = 'AUTHENTICATION',
    AUTHORIZATION = 'AUTHORIZATION',
    LICENSING = 'LICENSING',
}

export const MaestraSignalExceptionTypeSchema = z.enum(MaestraSignalExceptionType);
